import $ from 'jquery';
import { showLoader, hideLoader } from 'common/utils/rbacHelpers';
import { createQueryString } from 'common/utils/queryStringUtils';
import { RBAC_PRODUCT_AREAS } from 'common/constants/rbacProductAreas';

$(function () {
  var maxSelectedItemsToRender = 500;
  var currentRequest = null;
  const loaderElementName = 'teams-loading-icon';
  const NODE_TYPE_TEAM = 'team';
  const NODE_TYPE_EMPLOYEE = 'employee';

  function isEqual(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) {
      return false;
    }

    for (const key in a) {
      const a_value = a[key];
      const b_value = b[key];
      if (
        (a_value instanceof Object && !isEqualObjects(a_value, b_value)) ||
        (!(a_value instanceof Object) && a_value !== b_value)
      ) {
        return false;
      }
    }
    return true;
  }

  function uniqWith(arr, fn) {
    return arr.filter(
      (element, index) => arr.findIndex(step => fn(element, step)) === index
    );
  }

  function differenceWith(arr, values, comparator) {
    return arr.filter(item => !values.some(value => comparator(item, value)));
  }

  function updateEmployeeIds() {
    var selectedArray = $('#teams-select').data('selected-nodes') || [];

    var employeeIds = selectedArray.reduce(function (acc, node) {
      if (node.nodeType === NODE_TYPE_EMPLOYEE) {
        acc.push(node.employeeId);
      }
      return acc;
    }, []);

    $('#employee_ids').val(employeeIds.join()).change();
  }

  function updateTeamIds() {
    var selectedArray = $('#teams-select').data('selected-nodes') || [];

    var teamIds = selectedArray.reduce(function (acc, node) {
      if (node.nodeType === NODE_TYPE_TEAM) {
        acc.push(node.teamId);
      }
      return acc;
    }, []);

    $('#team_ids').val(teamIds.join()).trigger('change');
  }

  function requestNextPage($container, data) {
    if (data._links && data._links.next) {
      $container.data('next-page', data._links.next.href);
    } else {
      $container.data('next-page', '');
    }
  }

  function clearNextPage($container) {
    $container.data('next-page', '');
  }

  function fetchNodes(nodeId, callBack) {
    var $container = $('#teams-items-container');
    var includeDeactivated = $('#include_deactivated').prop('checked');
    var url = nodeId
      ? `/api/v1/team_tree/${nodeId}/children`
      : `/api/v1/team_tree/root/children`;
    var paramsStr = createQueryString({
      active: includeDeactivated ? '' : true,
      product_area: RBAC_PRODUCT_AREAS.FEEDBACK,
    });

    if (currentRequest) currentRequest.abort();

    clearNextPage($container);

    showLoader(loaderElementName);
    currentRequest = $.get(`${url}?${paramsStr}`, callBack);
  }

  function fetchAllTeamMemberIds(teamLeadId, callBack) {
    var $container = $('#teams-items-container');
    var includeDeactivated = $('#include_deactivated').prop('checked');
    var url = `/api/v1/team_tree/${teamLeadId}/descendants`;
    var paramsStr = createQueryString({
      active: includeDeactivated ? '' : true,
      product_area: RBAC_PRODUCT_AREAS.FEEDBACK,
    });

    if (currentRequest) currentRequest.abort();

    clearNextPage($container);

    showLoader(loaderElementName);
    currentRequest = $.get(`${url}?${paramsStr}`, callBack);
  }

  function fetchEmployeesInfo(nodeIds, callBack) {
    var url = `/api/v2/profiles/by_employee_id`;
    var params = {
      employee_ids: nodeIds,
      attributes: ['comma_name', 'custom_employee_id', 'employee_id'],
    };

    currentRequest = $.post(url, params, callBack);
  }

  function fetchTeamsInfo(nodeIds, callBack) {
    var url = '/api/v1/groups';
    var paramsStr = createQueryString({
      ids: nodeIds,
    });

    currentRequest = $.get(`${url}?${paramsStr}`, callBack);
  }

  function addNode(_index, nodeItem, searchText) {
    var selectedArray = $('#teams-select').data('selected-nodes') || [];
    var $container = $('#teams-items-container');
    var isFolder = nodeItem.with_descendants;

    var employeeId = nodeItem.employee_id;
    var teamId = isFolder ? nodeItem.owned_team_id : nodeItem.team_id;
    var teamLeadId = nodeItem.superior_id;

    var isSelected =
      selectedArray.findIndex(
        item =>
          (item.nodeType === NODE_TYPE_TEAM && item.teamId == teamId) ||
          (item.nodeType === NODE_TYPE_EMPLOYEE &&
            item.employeeId == employeeId)
      ) !== -1;

    var regEx = new RegExp(searchText, 'gi');

    var displayName = searchText
      ? nodeItem.employee_name.replace(regEx, function (text) {
          return `<span class="background-light-blue">${text}</span>`;
        })
      : nodeItem.employee_name;

    $container.append(`
      <li class="node ${isFolder ? 'folder' : 'single'}" data-node-name="${
        nodeItem.employee_name
      }" data-employee-id="${employeeId}" data-team-id="${teamId}" data-node-type="${
        isFolder ? NODE_TYPE_TEAM : NODE_TYPE_EMPLOYEE
      }" data-team-lead-id="${teamLeadId}">
        <div class="add-section padding-right-medium">
          <input ${
            isSelected ? 'checked' : ''
          } class="add button js-employee-checkbox unstyled hover-pointer" type="checkbox">
        </div>
        <div class="node-section">
          <div class="name-section">
            ${displayName}
          </div>
          <div class="icon-section hover-pointer padding-right-medium">
            ${
              isFolder
                ? '<i class="fas fa-angle-right" aria-hidden="true"></i>'
                : ''
            }
          </div>
        </div>
      </li>
    `);
    hideLoader(loaderElementName);
  }

  function renderFolderHeader(nodeId, nodeName) {
    var $container = $('#teams-items-container');

    $container.append(`
      <li class="folder-header padding-medium">
        <div class="tree-back-btn text-green hover-pointer">
          <i class="fas fa-angle-left" aria-hidden="true"></i>
          <span>back</span>
        </div>
        <div class="folder-name">
          <strong>${nodeName}</strong>
        </div>
      </li>
    `);
  }

  function renderFolder() {
    var $root = $('#teams-select');
    var levels = $root.data('level-stack') || [];
    var currentFolder = levels[levels.length - 1];
    var $container = $('#teams-items-container');

    $container.html('');
    renderFolderHeader(currentFolder.nodeId, currentFolder.nodeName);

    fetchNodes(currentFolder.nodeId, function (data) {
      hideLoader(loaderElementName);
      if (data && data.items) {
        $.each(data.items, addNode);

        requestNextPage($container, data);
      }
    });
  }

  function renderRootFolder() {
    var $root = $('#teams-select');
    var $container = $('#teams-items-container');
    $root.data('level-stack', []);

    fetchNodes(null, function (data) {
      hideLoader(loaderElementName);
      if (data && data.items) {
        $container.html('');
        $.each(data.items, addNode);

        requestNextPage($container, data);
      }
    });
  }

  function pushCurrentNodeToLevelStack(employeeId, nodeName) {
    var $root = $('#teams-select');
    var levels = $root.data('level-stack') || [];

    levels.push({ nodeId: employeeId, nodeName: nodeName });
    $root.data('level-stack', levels);
  }

  function renderSelections() {
    var $root = $('#teams-select');
    var selectedArray = $root.data('selected-nodes') || [];
    var $selectionsContainer = $('#teams-selected-items-container');
    var selectedCount =
      selectedArray.length > maxSelectedItemsToRender
        ? maxSelectedItemsToRender
        : selectedArray.length;
    var i = 0;
    var renderedStr = '';

    for (i = 0; i < selectedCount; i++) {
      renderedStr += `
        <div class="teams-selected-member">
          ${selectedArray[i].nodeName}
          <span data-employee-id="${selectedArray[i].employeeId}" data-team-id="${selectedArray[i].teamId}" data-node-type="${selectedArray[i].nodeType}" class="deselect-member cursor-pointer"><i class="fas fa-times" aria-hidden="true"></i></span>
        </div>
      `;
    }
    if (selectedArray.length > maxSelectedItemsToRender) {
      var moreSelectedCount = selectedArray.length - maxSelectedItemsToRender;
      renderedStr += `
        <div class="font-size-small padding-small">and ${moreSelectedCount} more.</div>
      `;
    }
    $selectionsContainer.html(renderedStr);
  }

  function updateSelection() {
    var selectedArray = $('#teams-select').data('selected-nodes') || [];
    var $container = $('#teams-items-container');

    $('li.node', $container).each(function (_index, node) {
      var employeeId = $(node).data('employee-id');
      var teamId = $(node).data('team-id');
      var nodeType = $(node).data('node-type');

      var isSelected =
        selectedArray.findIndex(
          item =>
            (nodeType === NODE_TYPE_EMPLOYEE &&
              item.employeeId == employeeId) ||
            (nodeType === NODE_TYPE_TEAM && item.teamId == teamId)
        ) !== -1;

      $('.js-employee-checkbox', $(node)).prop('checked', isSelected);
    });
  }

  function selectEmployee(employeeId, teamId, teamLeadId, nodeName) {
    var $root = $('#teams-select');
    var selectedArray = $root.data('selected-nodes') || [];

    selectedArray.push({
      employeeId,
      teamId,
      teamLeadId,
      nodeName,
      nodeType: NODE_TYPE_EMPLOYEE,
    });

    $root.data('selected-nodes', uniqWith(selectedArray, isEqual));

    renderSelections();
    updateEmployeeIds();
  }

  function deselectEmployee(employeeId, teamId, teamLeadId) {
    var $root = $('#teams-select');
    var selectedArray = $root.data('selected-nodes') || [];

    var employeeIndex = selectedArray.findIndex(
      item =>
        item.nodeType === NODE_TYPE_EMPLOYEE && item.employeeId == employeeId
    );

    if (employeeIndex !== -1) {
      selectedArray.splice(employeeIndex, 1);
    }

    var teamIndex = selectedArray.findIndex(
      item => item.nodeType === NODE_TYPE_TEAM && item.teamId == teamId
    );

    if (teamIndex !== -1) {
      selectedArray.splice(teamIndex, 1);

      fetchAllTeamMemberIds(teamLeadId, function (data) {
        if (data && data.items) {
          var team = Object.values(data.items).reduce(function (acc, member) {
            if (member.employee_id !== employeeId) {
              acc.push({
                employeeId: member.employee_id,
                teamId,
                teamLeadId,
                nodeName: member.comma_name,
                nodeType: NODE_TYPE_EMPLOYEE,
              });
            }
            return acc;
          }, []);

          $('#teams-select').data(
            'selected-nodes',
            uniqWith(selectedArray.concat(team), isEqual)
          );
          renderSelections();
          updateEmployeeIds();
          updateTeamIds();
        }
        hideLoader(loaderElementName);
      });
    } else {
      $root.data('selected-nodes', selectedArray);
      renderSelections();
      updateEmployeeIds();
    }
  }

  function selectTeam(teamId, teamleaderName) {
    var $root = $('#teams-select');
    var selectedArray = $root.data('selected-nodes') || [];

    selectedArray.push({
      teamId,
      nodeName: teamleaderName,
      nodeType: NODE_TYPE_TEAM,
    });

    $root.data('selected-nodes', uniqWith(selectedArray, isEqual));

    renderSelections();
    updateTeamIds();
  }

  function deselectTeam(teamId) {
    var $root = $('#teams-select');
    var selectedArray = $root.data('selected-nodes') || [];

    selectedArray.splice(
      selectedArray.findIndex(
        item => item.nodeType === NODE_TYPE_TEAM && item.teamId == teamId
      ),
      1
    );

    $root.data('selected-nodes', selectedArray);

    renderSelections();
    updateTeamIds();
  }

  // when checkbox clicked
  function handleChangeCheckbox() {
    var $nodeLi = $(this).closest('li.node');
    var isFolder = $nodeLi.hasClass('folder');
    var employeeId = $nodeLi.data('employee-id');
    var teamId = $nodeLi.data('team-id');
    var teamLeadId = $nodeLi.data('team-lead-id');
    var nodeName = $nodeLi.data('node-name');
    var isChecked = this.checked;

    if (isChecked) {
      if (isFolder) {
        selectTeam(teamId, nodeName);
      } else {
        selectEmployee(employeeId, teamId, teamLeadId, nodeName);
      }
    } else if (isFolder) {
      deselectTeam(teamId);
    } else {
      deselectEmployee(employeeId, teamId, teamLeadId);
    }
  }

  function removeNodeFromSelection() {
    var employeeId = $(this).data('employee-id');
    var teamId = $(this).data('team-id');
    var teamLeadId = $(this).data('team-lead-id');
    var nodeType = $(this).data('node-type');

    if (nodeType === NODE_TYPE_TEAM) {
      deselectTeam(teamId);
    } else {
      deselectEmployee(employeeId, teamId, teamLeadId);
    }
    updateSelection();
  }

  function handleAjaxSearch() {
    var searchText = $('#js-employee-tree-search input').val().trim();

    var $container = $('#teams-items-container');

    if (searchText.length > 0) {
      var includeDeactivated = $('#include_deactivated').prop('checked');

      if (currentRequest) currentRequest.abort();

      clearNextPage($container);
      var url = '/api/v1/team_tree';
      var paramsStr = createQueryString({
        active: includeDeactivated ? '' : true,
        q: searchText,
        product_area: RBAC_PRODUCT_AREAS.FEEDBACK,
      });

      showLoader(loaderElementName);
      currentRequest = $.get(`${url}?${paramsStr}`, function (data) {
        if (data && data.items) {
          $container.html('');
          $.each(data.items, function (_index, nodeItem) {
            addNode(_index, nodeItem, searchText);
          });

          requestNextPage($container, data);
        }
      });
    } else {
      clearNextPage($container);
      renderRootFolder();
    }
  }

  var handleTeamsItemsScroll = function () {
    var $container = $('#teams-items-container');
    var nextPageUrl = $('#teams-items-container').data('next-page');
    var searchText = $('#js-employee-tree-search input').val().trim();

    if (
      $(this).scrollTop() + $(this).innerHeight() >=
      $(this)[0].scrollHeight
    ) {
      if (nextPageUrl === '') {
        return;
      }

      if (currentRequest) currentRequest.abort();

      clearNextPage($container);

      currentRequest = $.get(nextPageUrl, function (data) {
        $.each(data.items, function (_index, nodeItem) {
          addNode(_index, nodeItem, searchText);
        });

        requestNextPage($container, data);
      });
    }
  };

  function levelUp() {
    var $root = $('#teams-select');
    var levels = $root.data('level-stack') || [];

    levels.pop();
    if (levels.length > 0) {
      setTimeout(renderFolder, 0);
    } else {
      handleAjaxSearch();
    }
  }

  function clearAllSelection() {
    $('#teams-select').data('selected-nodes', []);
    $('#js-employee-tree-search input').val('');
    handleAjaxSearch();
    updateSelection();
    renderSelections();
    updateEmployeeIds();
    updateTeamIds();
  }

  function bindNodesClicks($root) {
    $root.on('click', '.node-section', function () {
      var $target = $(this);
      var $nodeLi = $target.parent();
      var employeeId = $nodeLi.data('employee-id');
      var nodeName = $nodeLi.data('node-name');
      var isFolder = $nodeLi.hasClass('folder');

      if (isFolder) {
        pushCurrentNodeToLevelStack(employeeId, nodeName);
        setTimeout(renderFolder, 0);
      }
    });

    $root.on('click', '.tree-back-btn', levelUp);
  }

  function bindSelect($root) {
    $root.on('click', '.js-employee-checkbox', function (e) {
      e.stopPropagation();
    });
    $root.on('change', '.js-employee-checkbox', handleChangeCheckbox);

    $root.on('click', '.deselect-member', removeNodeFromSelection);
  }

  function debounce(func, delay, { leading } = {}) {
    let timerId;

    return function (...args) {
      const ctx = this;

      if (!timerId && leading) {
        func.apply(ctx, args);
      }
      clearTimeout(timerId);

      timerId = setTimeout(() => func.apply(ctx, args), delay);
    };
  }

  function bindChange($root) {
    $('#js-employee-tree-search input', $root).on(
      'input',
      debounce(handleAjaxSearch, 500)
    );
  }

  function bindClearSelection($root) {
    $root.on('click', '.link.js-deselect-all', clearAllSelection);
  }

  function bindClearFilters() {
    $('.js-clear-filters').click(clearAllSelection);
  }

  function bindScroll() {
    var $container = $('#teams-items-container');

    $container.on('scroll', handleTeamsItemsScroll);
  }

  function bindFocus($root) {
    var $container = $('#teams-items-container');

    $('#js-employee-tree-search input', $root).on('focus', function () {
      var searchText = $('#js-employee-tree-search input').val().trim();

      if (!$root.hasClass('opened')) {
        $root.addClass('opened');
        if (searchText) {
          handleAjaxSearch();
        } else {
          renderRootFolder();
        }
      }
    });
  }

  function closeDropDown($root) {
    var $container = $('#teams-items-container');

    clearNextPage($container);
    $root.removeClass('opened');
  }

  function restoreState() {
    var teamIds = $('#team_ids').val();
    var employeeIds = $('#employee_ids').val();

    if (teamIds) {
      var selectedTeamsArray = teamIds.split(',') || [];

      fetchTeamsInfo(selectedTeamsArray, function (data) {
        if (data && data.groups.length > 0) {
          var teams = data.groups.map(function (team) {
            return {
              teamId: team.id,
              nodeName: team.name,
              nodeType: NODE_TYPE_TEAM,
            };
          });
          var selectedArray = $('#teams-select').data('selected-nodes') || [];
          $('#teams-select').data('selected-nodes', [
            ...selectedArray,
            ...teams,
          ]);

          updateSelection();
          renderSelections();
        }
      });
    }

    if (employeeIds) {
      var selectedEmployeesArray = employeeIds.split(',') || [];

      fetchEmployeesInfo(selectedEmployeesArray, function (data) {
        if (data && Array.isArray(Object.keys(data))) {
          var employees = Object.keys(data).map(function (employeeId) {
            return {
              employeeId: parseInt(employeeId, 10),
              nodeName: data[employeeId].comma_name,
              nodeType: NODE_TYPE_EMPLOYEE,
            };
          });
          var selectedArray = $('#teams-select').data('selected-nodes') || [];
          $('#teams-select').data('selected-nodes', [
            ...selectedArray,
            ...employees,
          ]);

          updateSelection();
          renderSelections();
        }
      });
    }
  }

  function setupTeamTree() {
    var $root = $('#teams-select');
    $root.data('selected-nodes', []);
    $root.data('level-stack', []);

    bindChange($root);
    bindNodesClicks($root);
    bindSelect($root);
    bindClearSelection($root);
    bindClearFilters();
    bindScroll();
    bindFocus($root);
    if (!$('#team_or_group').val() || $('#team_or_group').val() === 'teams') {
      restoreState();
    }

    // Close Dropdown if click outside of it
    $(document).click(event => {
      if ($(event.target).closest($root).length === 0) {
        closeDropDown($root);
      }
    });

    $('a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
      if ($(e.target).attr('href') === '#groups') {
        $('#team_or_group').val('groups').change();
        clearAllSelection();
      }
    });
  }

  if ($('#teams-select').length) {
    setupTeamTree();
  }
});
